"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import Api from "../api/api";
import ApiService from "../services/api_service";
import DataStoreService from "./data_store_service";
import DisablingButton from "./disabling_button";
import "../services/email_service";
import fetch from "../util/fetch";
import reactUtils from "../react_utils";
import "../components/waiting_spinner";
var bem = reactUtils.makeBem("email-label-editor");
function labelOption(label) {
  return /* @__PURE__ */ jsx("option", { value: label.name, children: label.name }, "label-" + label.name);
}
function availableLabels(state) {
  const accountLabels = Api.Account.current().labels;
  const available = _.reject(accountLabels, (al) => {
    _.some(state.email.labels, (l) => al.name === l || al.name === l.name);
  });
  return _.sortBy(available, (l) => l.name);
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      addingLabel: false,
      email: this.props.email,
      saving: false,
      label: null,
      labelErrorMessage: null
    });
    __publicField(this, "labelsList", () => {
      const labels = _.map(this.state.email.labels, this.labelDisplay);
      if (!_.isEmpty(labels)) {
        return /* @__PURE__ */ jsx("div", { className: bem("__labels-list"), children: labels });
      }
    });
    __publicField(this, "labelDisplay", (label) => {
      const labelName = label["name"] || label;
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: "carrier-labels__label " + bem("__label-display"),
          children: this.labelDisplayContent(labelName)
        },
        labelName
      );
    });
    __publicField(this, "labelDisplayContent", (labelName) => {
      if (this.state.saving) {
        return "saving....";
      } else {
        return /* @__PURE__ */ jsxs("div", { children: [
          this.labelDeleteLink(labelName),
          labelName
        ] });
      }
    });
    __publicField(this, "labelDeleteLink", (labelName) => {
      return /* @__PURE__ */ jsx(
        "a",
        {
          onClick: (e) => {
            this.sendData(e, labelName);
          },
          children: /* @__PURE__ */ jsx("i", { className: "fi-x-circle" })
        }
      );
    });
    __publicField(this, "sendData", (e, name) => {
      e.preventDefault();
      this.setState({ saving: true });
      ApiService.addErrorHandler(
        fetch("/api/email_messages/" + this.state.email.id + "/labels", {
          data: { label_name: name || this.state.label },
          method: name ? "DELETE" : "POST"
        }),
        null,
        { caller: "EmailLabelEditor.sendData" }
      ).then((data) => {
        if (data.error) {
          this.setState({ saving: false, labelErrorMessage: data.error });
        } else {
          this.setState({ email: data.email_messages[0] });
          DataStoreService.updateStores(data);
          this.stopAddingLabel();
          this.setState({
            saving: false,
            label: availableLabels(this.state)[0].name
          });
        }
      }).catch((data) => {
        this.setState({ saving: false });
      });
    });
    __publicField(this, "possibleNewLabelArea", () => {
      if (this.state.addingLabel) {
        if (_.isEmpty(availableLabels(this.state))) {
          return /* @__PURE__ */ jsxs(
            "div",
            {
              className: "alert-box highlight " + bem("__all-labels-added-alert"),
              children: [
                "All available labels have been added.",
                /* @__PURE__ */ jsx("a", { className: "close", onClick: this.stopAddingLabel, children: "\xD7" })
              ]
            }
          );
        } else {
          return /* @__PURE__ */ jsxs("div", { className: bem("__new-label-container"), children: [
            this.newLabelSelect(),
            this.newLabelSaveButton(),
            this.newLabelCloseButton()
          ] });
        }
      }
    });
    __publicField(this, "addLabelLink", () => {
      if (!this.state.addingLabel) {
        return /* @__PURE__ */ jsx("div", { className: bem("__add-label-icon"), children: /* @__PURE__ */ jsxs("a", { onClick: this.startAddingLabel, children: [
          /* @__PURE__ */ jsx("i", { className: "fi-plus" }),
          "\xA0Add Label"
        ] }) });
      }
    });
    __publicField(this, "stopAddingLabel", () => {
      this.setState({ addingLabel: false });
    });
    __publicField(this, "startAddingLabel", () => {
      this.setState({ addingLabel: true });
    });
    __publicField(this, "newLabelSelect", () => {
      return /* @__PURE__ */ jsx("div", { className: bem("__new-label-select"), children: /* @__PURE__ */ jsx(
        "select",
        {
          value: this.state.label || "",
          onChange: (e) => this.setState({ label: e.target.value }),
          children: _.map(availableLabels(this.state), labelOption)
        }
      ) });
    });
    __publicField(this, "newLabelCloseButton", () => {
      return /* @__PURE__ */ jsx("div", { className: bem("__close-button"), children: /* @__PURE__ */ jsx(
        DisablingButton,
        {
          className: "button--cancel",
          disabled: this.state.saving,
          disabledText: "Cancel",
          onClick: this.stopAddingLabel,
          children: "Cancel"
        }
      ) });
    });
    __publicField(this, "newLabelSaveButton", () => {
      return /* @__PURE__ */ jsx("div", { className: "button--confirmation--container", children: /* @__PURE__ */ jsx(
        DisablingButton,
        {
          className: "button--confirmation",
          disabled: this.state.saving,
          disabledText: "Saving....",
          onClick: (e) => {
            this.sendData(e, "");
          },
          children: "Add"
        }
      ) });
    });
  }
  componentDidMount() {
    if (!_.isEmpty(availableLabels(this.state))) {
      this.setState({
        label: availableLabels(this.state)[0].name || availableLabels(this.state)[0]
      });
    }
  }
  render() {
    return /* @__PURE__ */ jsxs("div", { children: [
      this.labelsList(),
      this.possibleNewLabelArea(),
      this.addLabelLink()
    ] });
  }
}
